import React from "react";
import logo from '../../../logo.jpg';
import styles from './about.module.css';

function AboutUsPage() {
    return (
        <div className={styles.container}>
            {/* Header / Hero Section */}
            <header className={styles.hero}>
                <img src={logo} alt="Logo da Empresa" className={styles.logo} />
                <h1 className={styles.title}>Forjado em Blumenau</h1>
                <p className={styles.subtitle}>Rigor militar, excelência artesanal e tradição sulista.</p>
            </header>

            {/* Seção Sobre */}
            <section className={styles.contentSection}>
                <div className={styles.textBlock}>
                    <h2 className={styles.sectionTitle}>Nossa Herança</h2>
                    <p>
                        Localizada no coração do Vale do Itajaí, nossa história se funde com a 
                        tradição de excelência de Blumenau. Nascemos para atender aqueles que sabem que 
                        a apresentação individual é o primeiro passo para o comando e o respeito.
                    </p>
                    <p>
                        Diferente da produção em massa, cada peça que sai de nossa oficina é 
                        fruto de um trabalho artesanal minucioso. Utilizamos matérias-primas 
                        de alta resistência para garantir que o seu equipamento suporte o rigor 
                        do campo, mantendo o alinhamento impecável que a farda exige.
                    </p>
                </div>
                <div className={styles.imagePlaceholder}>
                    {/* Espaço para imagem da produção artesanal ou detalhe de costura */}
                    <span>Precisão nos Detalhes</span>
                </div>
            </section>

            {/* Seção de Valores (Grid) */}
            <section className={styles.valuesSection}>
                <div className={styles.valueCard}>
                    <h3>Artesanal</h3>
                    <p>Costuras reforçadas e acabamento manual que máquinas automáticas não replicam.</p>
                </div>
                <div className={styles.valueCardHighlight}>
                    <h3>Apresentação</h3>
                    <p>Foco total na estética e no garbo militar. Onde a funcionalidade encontra a honra.</p>
                </div>
                <div className={styles.valueCard}>
                    <h3>Resistência</h3>
                    <p>Desenvolvido no Sul para enfrentar qualquer clima e terreno com durabilidade extrema.</p>
                </div>
            </section>
        </div>
    );
};

export default AboutUsPage;